'use client'

import { Button, ButtonGroup } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { List, ListItem } from '@wartek-id/list'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'

import { ErrorDialog } from '@/components/ErrorDialog/ErrorDialog'

export const ButtonDownloadView = ({
  disabled = false,
  isPending = false,
  isShowErrorDialog = false,
  onCloseErrorDialog = () => {},
  onDownload = (_fileType) => {},
}: {
  disabled?: boolean
  isPending?: boolean
  isShowErrorDialog?: boolean
  onCloseErrorDialog?: () => void
  onDownload?: (fileType: 'csv' | 'xlsx' | 'pdf') => void
}) => {
  return (
    <>
      <ButtonGroup color="blue">
        <Button
          onClick={() => {
            onDownload('xlsx')
          }}
          className="!rounded-l"
          data-testid="btn-download"
          disabled={disabled || isPending}
        >
          Unduh Data
        </Button>
        <Popover>
          <PopoverTrigger as="div">
            <Button
              iconOnly
              className="!rounded-r"
              data-testid="btn-expander"
              aria-label="Expand more"
              disabled={disabled || isPending}
            >
              <Icon color="inherit">expand_more</Icon>
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <List type="menu">
              <ListItem
                disabled={disabled || isPending}
                onClick={() => {
                  onDownload('xlsx')
                }}
                className="w-[150px]"
                data-testid="item-xlsx"
              >
                XLSX
              </ListItem>
              <ListItem
                disabled={disabled || isPending}
                onClick={() => {
                  onDownload('csv')
                }}
                className="w-[150px]"
                data-testid="item-csv"
              >
                CSV
              </ListItem>
              <ListItem
                disabled={disabled || isPending}
                onClick={() => {
                  onDownload('pdf')
                }}
                className="w-[150px]"
                data-testid="item-pdf"
              >
                PDF
              </ListItem>
            </List>
          </PopoverContent>
        </Popover>
      </ButtonGroup>

      <ErrorDialog
        show={isShowErrorDialog}
        onClose={onCloseErrorDialog}
        title="Gagal mengunduh"
        message="Maaf, terjadi kesalahan saat mengunduh berkas. Silahkan coba beberapa saat lagi atau unduh berkas lainnya."
      />
    </>
  )
}
